import { render, staticRenderFns } from "./TheHomeAddDatasetSpace.vue?vue&type=template&id=3ce58b78&"
import script from "./TheHomeAddDatasetSpace.vue?vue&type=script&lang=js&"
export * from "./TheHomeAddDatasetSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports